import * as React from 'react';
import { SVGProps } from 'react';

const IconChatFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.007 15c-.302 0-.504-.1-.705-.3-.302-.3-.403-.7-.201-1l1.107-3.4c-.402-.9-.503-1.7-.503-2.6 0-2.5 1.41-4.8 3.725-6 .907-.5 1.914-.7 2.92-.7h.303c3.423.2 6.142 2.9 6.343 6.3v.4c0 1-.201 2.1-.705 3-1.107 2.3-3.423 3.7-6.041 3.7-.906 0-1.813-.2-2.618-.5L2.208 15h-.201Z" />
  </svg>
);
export default IconChatFilledSizeS;
